module.exports = __webpack_public_path__ + "img/independent-game-studio-logo_agatis.e826777c.svg";